










import { Vue, Component } from 'vue-property-decorator';
import { TagsViewModule } from '@/store/modules/tagsView';

@Component
export default class AppMain extends Vue {

  public get cachedViews(): string {
    console.log(TagsViewModule.getters);
    return this.$store.state.tagsView.cachedViews;
  }


  public get key(): string {
    return this.$route.fullPath;
  }


}
